import { useMemo, useState } from "react";
import { Accordion, AccordionDetails, AccordionSummary, Box, Button,Grid, InputLabel, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FormWrapper from "../../form-builder/components/common/FormWrapper";
import FormField from "../../form-builder/components/common/FormField";
import dayjs from "dayjs";

const dataOptions=[{label:'SuperAdmin', value:'1'},{label:'CPM', value:'2'},{label:'QA', value:'3'}]
const FormGeneratorPermission = ({
  formJson,
  onSubmit,
  loading,
  formData,
  // setDFormData,
}) => {
const [expandedIndex, setExpandedIndex] = useState(0);

  const fieldTypeMap = {
    General: "text",
    Note: "textarea",
    Validations: "text",
    Label: "label",
    Toggle: "switch",
    "Input Radio": "radio-group",
    "Input Dropdown": "select",
    "Input Text": "text",
    "Input Number": "number",
    "Static Number": "number",
    "Input Email": "email",
    "Input Current Time": "time",
    "Input Date": "date",
    "Input Date and Time": "datetime",
    "Linked Field": "linked-field",
    Hyperlink: "hyperlink",
    "File Upload": "file",
    "Image Upload": "image_upload",
    Barcode: "barcode",
  };

  const layoutOptions = {
    12: { gridSize: 12, cols: 1 },
    6: { gridSize: 6, cols: 2 },
    4: { gridSize: 4, cols: 3 },
    3: { gridSize: 3, cols: 4 },
  };

  const processSections = (sections) => {
    return sections?.map((section) => {
      const sortedFields = [...section.fields].sort(
        (a, b) => a.order - b.order
      );

      const fieldGroups = [];
      let currentGroup = [];
      let currentLayout = null;

      sortedFields.forEach((field) => {
        const fieldLayout = field.property.field_layout || 12;

        if (currentLayout !== fieldLayout) {
          if (currentGroup.length > 0) {
            fieldGroups.push({
              layout: currentLayout,
              fields: currentGroup,
            });
          }
          currentGroup = [];
          currentLayout = fieldLayout;
        }

        currentGroup.push({
          ...field,
          type: fieldTypeMap[field.property.field_type] || "text",
          required: field.property.general?.required || false,
        });
      });

      if (currentGroup.length > 0) {
        fieldGroups.push({
          layout: currentLayout,
          fields: currentGroup,
        });
      }

      return {
        ...section,
        fieldGroups,
      };
    });
  };

  const formSections = processSections(formJson);
  
  const getFieldOptions = (fieldUuid) => {
  for (const section of formJson) {
    for (const field of section.fields) {
      if (field.input_uuid === fieldUuid) {
        const opts = field?.property?.options?.options || [];
        return opts.map((opt) => ({
          value: opt.option_uuid,
          label: opt.label,
        }));
      }
    }
  }
  return [];
};


  const handleFieldChange = (fieldUuid, value) => {
    console.log(fieldUuid, value,'fieldUuid, value')
    // setDFormData((prev) => {
    //   const updatedSections = prev.sections.map((section) => ({
    //     ...section,
    //     fields: section.fields.map((field) =>
    //       field.input_uuid === fieldUuid ? { ...field, value } : field
    //     ),
    //   }));

      // return { ...prev, sections: updatedSections };
    // });
  };

  const getHiddenFields = () => {
    const hidden = [];

    if (!formData?.sections?.length) return hidden;
    const allFields = formData.sections.flatMap((s) => s.fields || []);
    const fieldsWithConditions = allFields.filter(
      (f) => f.property?.conditions?.length
    );
    fieldsWithConditions.forEach((fieldItem) => {
      const selectedValue = allFields.find(
        (f) => f.input_uuid === fieldItem.input_uuid
      )?.value;
      fieldItem.property.conditions.forEach((cond) => {
        if (cond.fbt_option_uuid !== selectedValue) {
          hidden.push(cond.target_input_field_uuid);
        }
      });
    });

    return hidden;
  };

  const hiddenFields = getHiddenFields();

  const allOptionsDict = useMemo(() => {
  const dict = {};
  formJson.forEach(section => {
    section.fields.forEach(field => {
      field?.property?.options?.options?.forEach(opt => {
        dict[opt.option_uuid] = opt.label;
      });
    });
  });
  return dict;
}, [formJson]);

const handleAccordionChange = (index) => (event, isExpanded) => {
  setExpandedIndex(isExpanded ? index : null);
};

// const onSubmit=()=>{

// }
  return (
    <FormWrapper onSubmit={onSubmit} loading={loading} className="p-3">
      {formSections.map((section, index) => (
        <Box key={section?.section_uuid}    sx={{
        border: `1px solid ${expandedIndex === index ? "#1c5fdaff" : "#E0E0E0"}`,
        borderRadius: "8px",
        mb: 2,
        overflow: "hidden",
        }}>
          
          <Box className="w-full border border-gray-200 rounded-md bg-white">
            <Box className="p-3 border-b border-gray-200">
                <Typography
                  variant="subtitle1"
                  sx={{ fontSize: "1rem" }}
                  className="font-semibold text-blue-600"
                >
                  {section?.name}
                </Typography>
              {section?.description && (
                <Typography
                 variant="body2"
                className="text-gray-500 mt-1"
                   sx={{ fontSize: "o.875rem" }}
                >
                  {section?.description}
                </Typography>
              )}
            </Box>

            {/* Permissions */}
            <Box className="px-6 py-6 space-y-6">
              <Box className="grid grid-cols-12 items-center gap-4">
                <InputLabel className="col-span-2 font-bold text-gray-800">View Permission</InputLabel>
                <Box className="col-span-10">
                  <FormField
                    name={`view_permission4${index}`}
                    type="select"
                    size="small"
                    fullWidth
                    placeholder="Select the type"
                    className="flex"
                    options={dataOptions}
                  />
                </Box>
              </Box>

              <Box className="grid grid-cols-12 items-center gap-4">
                <InputLabel className="col-span-2 font-bold text-gray-800">Form Fill Permission</InputLabel>
                <Box className="col-span-10">
                  <FormField
                    name={`form_fill_permission4${index}`}
                    type="select"
                    size="small"
                    fullWidth
                    placeholder="Select the type"
                    className="flex"
                    options={dataOptions}
                  />
                </Box>
              </Box>
            </Box>
          </Box>

          <Accordion expanded={expandedIndex === index}
          onChange={handleAccordionChange(index)}
            elevation={0}
            sx={{
              border: "none",
              margin: "0px",
              "&:before": { display: "none" },
            }}
          >
            {(section?.property?.display_details ||
              section?.property?.display_field_number) && (
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                className="border-bottom m-0 px-2 expanded-accordian p-[0.5rem]"
                  sx={{
              // 
              // backgroundColor: `${isSectionsPermission?"#EEF4FF": expandedIndex === index ? "#EEF4FF" : "transparent"}`,
              borderBottom: "1px solid #E0E0E0",
              background: '#EEF4FF',
              minHeight: "64px",
              "& .MuiAccordionSummary-content": {
                margin: 0,
                display: "block",
                padding:"0.5rem"
              },
            }}
              >
                 <Typography variant="body1" sx={{ fontWeight: "600" , color:"#3571FF"}} >
                  {expandedIndex===index?'Hide Input Fields' :'Show Input Fields'}</Typography>          
              </AccordionSummary>
            )}

            <AccordionDetails className="p-0 px-2">
              {section.fieldGroups.map((group, groupIndex) => (
                <Grid key={groupIndex} container>
                  {group.fields.map((field) => {
                    if (hiddenFields.includes(field.input_uuid)) {
                      return null;
                    }
                    const fieldValue =
                      formData.sections
                        .flatMap((s) => s.fields)
                        .find((f) => f.input_uuid === field.input_uuid)
                        ?.value ||
                      field.value ||
                      "";

                    const showFormula = field?.property?.calculation
                      ?.display_formula
                      ? JSON.parse(
                          field?.property?.calculation?.display_formula
                        )
                      : false;
                    const calulationProp = field?.property?.calculation;
                    return (
                      <Grid
                        item
                        key={field.input_uuid}
                        xs={12}
                        sm={layoutOptions[group.layout]?.gridSize || 12}
                      >
                        <Box sx={{ paddingTop: "1rem", padding:1 }}>
                          {
                            field.type === "label" ? (
                              <Typography variant="body" className="text-sm font-bold">{field?.label}</Typography>

                            ) : (
                              <Typography
                                  variant="subtitle1"
                                  className="inline-block font-normal"
                                  sx={{ paddingBottom: "0.625rem" }}
                                >
                                  {field?.label}{" "}
                                  {calulationProp?.unit_of_measurement
                                    ? `(${calulationProp?.unit_of_measurement})`
                                    : ""}
                                {field?.property?.general?.required && (
                                  <Box
                                    component="span"
                                    className="text-red-500"
                                    sx={{ ml: 0.5 }}
                                  >
                                    *
                                  </Box>
                                )}
                              </Typography>
                            )
                          }
                    {/* @info bind up with the label may remove */}
                          {/* <Typography variant="subtitle1">
                            {calulationProp?.unit_of_measurement
                              ? `(${calulationProp?.unit_of_measurement})`
                              : ""}
                          </Typography> */}
                          {field.property.field_type === "Calculation" ? (
                            <>
                              <FormField
                                name={field.input_uuid}
                                type="number"
                                label=""
                                fullWidth
                                value={fieldValue}
                                disabled
                                size="small"
                              />
                              {showFormula && calulationProp?.formula && (
                                <Typography variant="caption">
                                  Formula: {field?.parsedFormula}
                                </Typography>
                              )}
                            </>
                          ) :
                          field.property.field_type === "Linked Field" ? (
                            <>
                              <FormField
                                name={field.input_uuid}
                                label=""
                                fullWidth
                                value={allOptionsDict[fieldValue] || fieldValue || field.property.linked_field?.linked_field || ""}
                                disabled
                                size="small"
                              />
                            </>) :
                            (
                              <FormField
                                // name={field.input_uuid}
                                name={`sections.${[index]}.fields.${[0]}.${field?.label}`}
                                type={field.type}
                                options={
                                  field.type === "radio-group" || field.type === "select"
                                    ? getFieldOptions(field.input_uuid)
                                    : []
                                }
                                row="row"
                                noMargin={true}
                                placeholder={
                                  field.placeholder ||
                                  `Enter ${field.label?.toLowerCase() || "value"}`
                                }
                                hasBothLabels={field.type === "Toggle"}
                                label1={field?.property?.toggle?.toggle_msg_1}
                                label2={field?.property?.toggle?.toggle_msg_2}

                                onChange={(input) => {
                                  let rawValue;

                                  // Detect value type
                                  if (typeof input === "object" && input !== null && input.$d) {
                                    rawValue = input; // Date object from MUI pickers
                                  } else if (input?.target) {
                                    rawValue = input.target.value; // Normal input event
                                  } else {
                                    rawValue = input; // Direct value (e.g. toggle, select, radio)
                                  }

                                  let finalValue = rawValue;

                                  switch (field.property.field_type) {

                                    case "Input Date":
                                      finalValue = rawValue ? dayjs(rawValue).format("YYYY-MM-DD") : "";
                                      break;

                                    case "Input Current Time":
                                      finalValue = rawValue || "";
                                      break;

                                    case "Input Date and Time":
                                      finalValue = rawValue ? dayjs(rawValue).toISOString() : "";
                                      break;

                                    default:
                                      // keep rawValue
                                      finalValue = rawValue;
                                      break;
                                  }

                                  handleFieldChange(field.input_uuid, finalValue);
                                }}
                                format={field.property.field_type === "Input Date" ? field?.property?.input_date?.date_display_format : 'DD/MM/YY'}
                                timeFormat={field.property.field_type === "Input Current Time" ? field?.property?.input_current_time?.time_format : 'hh:mm A'}

                                combineDate={field.property.field_type === "Input Date and Time" ? field?.property?.input_date_and_time?.date_display_format : 'DD/MM/YY'}
                                combineTime={field.property.field_type === "Input Date and Time" ? field?.property?.input_date_and_time?.time_format : 'HH:mm'}

                                linkLabel={field?.property?.hyperlink?.name}
                                linkUrl={field?.property?.hyperlink?.url}
                                defaultValue={field.property.field_type === "Input Text" ? field?.property?.input_text?.default_val : ''}
                              />)}                        
                        </Box>
                        <Typography
                          variant="body"
                          className="px-2"
                          sx={{ mb: 1, color: "#FB9D2C"}}
                        >
                          {field?.property?.note?.message_note
                            ? `Note : ${field?.property?.note?.message_note}`
                            : ""}
                        </Typography>
                        {/* <Divider sx={{ mb: "0.9rem" }} /> */}
                      </Grid>
                    );
                  })}
                </Grid>
              ))}
            </AccordionDetails>
          </Accordion>
        </Box>
      ))}

      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Button
          type="submit" //@info enabled to make it submit.
          variant="contained"
          disabled={loading}
          sx={{
            borderRadius: "0.375rem",
            width: "7.18rem",
          }}
        >
          Save
        </Button>
      </Box>


    </FormWrapper>
  );
};

export default FormGeneratorPermission